import useForm from "../../../../forms/hooks/useForm";

export default function useOrganizationForm() {
	return useForm({
		defaultValues: {
			name: "",
			languageDefault: "",
		},
	});
}
